
export const GetTxnDropdown = async () => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    try {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        const response = await fetch(`${ApiURL}txn/dropdown`, requestOptions);
        const result = await response.json();
        const responseData = result.data;

        return responseData;
    } catch (error) {
        console.log('Error:', error);
        throw error;
    }
}

export const GetBincard = async (product, transaction, location, serial) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                "product": product,
                "location": location,
                "txnType": transaction,
                "serial": serial
            })
        };

        const response = await fetch(`${ApiURL}Bincard/getBincard`, requestOptions);
        const result = await response.json();

        if (result.success) {
            return { success: true, data: result.data };
        }

        return { success: false, data: result.data };
    } catch (error) {
        console.error("BincardGet error:", error);
        throw error; // Rethrow the error to be handled by the caller
    }
};


export const DownloadBincard = async (product, transaction, location, fromDate, toDate, logUser, logLocation) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                "product": product,
                "location": location,
                "txnType": transaction,
                "fromDate": fromDate,
                "toDate": toDate,
                "logUser": logUser,
                "logLocation": logLocation
            })
        };

        const response = await fetch(`${ApiURL}Bincard/export`, requestOptions);

        // Check if the request was successful (status code in the range of 200-299)
        if (response.ok) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'bincard_export.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            // Handle unsuccessful response (status code outside the range of 200-299)
            const errorData = await response.json(); // Assuming the server returns JSON
            console.error('Error:', errorData);
        }
        
    } catch (error) {
        console.error("BincardGet error:", error);
        throw error; // Rethrow the error to be handled by the caller
    }
};




export const GetProductSearch = async (product, location) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        const response = await fetch(`${ApiURL}Product/varientsearch/${product}/${location}`, requestOptions);
        const result = await response.json();

        if (result.success) {
            return { success: true, data: result.data };
        }

        return { success: false, data: result.data };
    } catch (error) {
        console.error("BincardGet error:", error);
        throw error; // Rethrow the error to be handled by the caller
    }
};


export const GetUserWiseLocations = async (username, logLocation) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            redirect: 'follow',
            body: JSON.stringify({
                "Username": username,
                "LogLocation": logLocation
            })
        };

        const response = await fetch(`${ApiURL}Locations/userwise/locations`, requestOptions);
        const result = await response.json();

        if (result.success) {
            return { success: true, data: result.data };
        }

        return { success: false, data: result.data };
    } catch (error) {
        console.error("BincardGet error:", error);
        return { success: false, data: [] };
    }
};



export const GetProductDescription = async (product) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            redirect: 'follow',
            body: JSON.stringify({
                "product": product,
            })
        };

        const response = await fetch(`${ApiURL}Product/getProductDesc`, requestOptions);
        const result = await response.json();

        if (result.success) {
            return { success: true, data: result.data };
        }

        return { success: false, data: result.data };
    } catch (error) {
        console.error("BincardGet error:", error);
        throw error; // Rethrow the error to be handled by the caller
    }
};